<div class="p-4" appDynamicScreenHeight>
  <mat-card class="p-12 mat-mdc-card mdc-card h-full mat-mdc-card-outlined mdc-card--outlined items-center justify-center" appearance="outlined">
    <app-empty-state [type]="emptyType" [label]="emptyLabelContent">
      <div class="text-center font-normal text-gray-900 mt-2" messageContent>
        {{emptyMessageContent}}
      </div>
    </app-empty-state>
  </mat-card>
</div>
